import { render, staticRenderFns } from "./Game7_xiaoxiaole.vue?vue&type=template&id=3ea18718&scoped=true&"
import script from "./Game7_xiaoxiaole.vue?vue&type=script&lang=js&"
export * from "./Game7_xiaoxiaole.vue?vue&type=script&lang=js&"
import style0 from "./Game7_xiaoxiaole.vue?vue&type=style&index=0&id=3ea18718&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ea18718",
  null
  
)

export default component.exports